const TOKEN_STORAGE_KEY = 'token';

const Token = {
    get: () => localStorage.getItem(TOKEN_STORAGE_KEY), // there is a need to get token from the store
    set: (token) => localStorage.setItem(TOKEN_STORAGE_KEY, token),
    remove: () => localStorage.removeItem(TOKEN_STORAGE_KEY)
}

export default Token;